import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalComponent } from '../modules/modal/modal.component';

export type ModalType = 'confirm' | 'error' | 'info';
export type ModalText = {
  bodyText?: string;
  bodyTitle: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  modalTitle?: string;
};

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private modalService: NgbModal) {}

  open(modalType: ModalType, text?: ModalText, config?: NgbModalOptions) {
    const MODAL_OPTIONS: NgbModalOptions = {
      size: 'sm',
      scrollable: true,
      centered: true,
      backdrop: 'static',
      keyboard: false,
    };

    const defaultText: ModalText = {
      modalTitle: text?.modalTitle ?? 'Confirm action',
      bodyTitle:
        text?.bodyTitle ?? 'Are you sure you want to perform next action?',
      bodyText: text?.bodyText ?? '',
      cancelButtonText: text?.cancelButtonText ?? 'Cancel',
      confirmButtonText: text?.confirmButtonText ?? 'Ok',
    };

    const modalRef = this.modalService.open(
      ModalComponent,
      config ?? MODAL_OPTIONS,
    );

    modalRef.componentInstance.modalType = modalType;
    modalRef.componentInstance.text = defaultText;

    return modalRef;
  }
}
